import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersCell } from './emsp-bo-rfid-badge-order-list-rfid-badge-visual-numbers.cell';
import { EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersHeader } from './emsp-bo-rfid-badge-order-list-rfid-badge-visual-numbers.header';

export const EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['rfidBadgeVisualNumbers']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersHeader,
  cell: EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersCell,
};
